<template>
  <div class="resultItem">
    <p class="title">{{title}}:</p>
    <p class="referenceValues">(<span v-if="refMinValue">{{refMinValue}}-</span>{{refMaxValue}}{{refUnit}})</p>
    <p class="resultValue"><span class="description">Tulos</span> {{resultValue}}%</p>
    <p class="resultValue" v-if="averageValue"><span class="description">Keskiarvo</span> {{averageValue}}{{refUnit}}</p>
    <div class="resultImage">
      <img class="resultImageIcon" :src="getImageUrl(icon)">
    </div>
  </div>
</template>

<script>
    export default {
      name: "CprResult",
      props:['title', 'refUnit', 'refMinValue', 'refMaxValue', 'resultValue', 'averageValue',  'icon'],
      methods: {
        getImageUrl(image){
          return require('../../assets/' + image);
        }
      }
    }
</script>

<style scoped>

  .resultItem {
    margin-top: 40px;
    margin-bottom: 40px;
  }

  .title {
    font-size: 24px;
    margin-bottom: 0;
  }

  .resultValue {
    font-size: 24px;
  }

  .resultImage{
    text-align: center;
  }

  .percentageCircle{
    width: 100px; height: 100px;
    border-radius: 50%;
    background: yellowgreen;
    position: relative;
    vertical-align: middle;
    display: inline-block;
  }
  .resultImageIcon {
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/Results/CprResult.vue